const initialState = {
    anchor: 'left',
    relatorio: [],
    id: 0,
    id_empresa: 0,
    inscricao_prefeitura: '',
    id_inseminador: 0,
    id_produtor: 0,
    tipo_relatorio: '',
    data_inicio: '',
    data_termino: ''
};

export function relatorio(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_RELATORIO':
            return {
                ...state,
                relatorio: action.relatorio
            };
        case 'RELATORIO_DETAIL':
            return {
                ...state,
                id: action.id,
                id_empresa: action.id_empresa,
                id_produtor: action.id_produtor,
                id_inseminador: action.id_inseminador,
                tipo_relatorio: action.tipo_relatorio,
                inscricao_prefeitura: action.inscricao_prefeitura,
                data_inicio: action.data_inicio,
                data_termino: action.data_termino
            };
        case 'RELATORIO_CLEAR':
            return {
                ...state,
                anchor: 'left',
                relatorio: [],
                id: 0,
                id_empresa: 0,
                id_produtor: 0,
                id_inseminador: 0,
                tipo_relatorio: '',
                inscricao_prefeitura: '',
                data_inicio: '',
                data_termino: ''
            };
        case "RELATORIO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
